<header>
  <div class="main-header apd-dark-theme">
    <div class="logo-container">
      <a [routerLink]="['/']" class="logo" cdkMonitorElementFocus (click)="clearSearch()" data-ai-id="nav-home">
        <div alt="DigitalWorkOrder"></div>
      </a>
      <div class="title-container">
        <h2 class="app-title">
          <a [routerLink]="['/']" data-ai-id="nav-home-title">Digital Work Order</a>
        </h2>
        @if (selectedProjectsLabel && !adminMode) {
          <div class="selected-projects">{{ selectedProjectsLabel }}</div>
        }
      </div>
    </div>

    <ng-content select="[apdTool]"></ng-content>

    @if (!offlineMode && !adminMode) {
      <div class="work-center-selection">
        <button [routerLink]="['/profile']" data-ai-id="nav-profile">
          <mat-icon class="mat-icon">settings</mat-icon>
        </button>
      </div>
    }

    <div class="toolbar-button-group">
      <button
        routerLink="/support"
        class="support-link"
        cdkMonitorElementFocus
        type="button"
        title="Support"
        aria-label="Support"
        data-ai-id="nav-support"
      >
        <mat-icon>contact_support</mat-icon>
      </button>
      @if (!hideUserLogin) {
        <app-user class="apd-user">
          <ng-content select="[apdHeaderMenuItems]"></ng-content>
        </app-user>
      }
    </div>
  </div>
  @if (isLoading | async) {
    <mat-progress-bar [style.animation]="'apd-fade-in ' + animationTime" mode="indeterminate"> </mat-progress-bar>
  }
</header>
